import styled from 'styled-components';

export default styled.p`
  padding-inline: 20px;
  margin-bottom: 22px;
  text-align: center;

  &:first-of-type {
    margin-top: 29px;
  }

  &:last-child {
    margin-bottom: 29px;
  }
`;
